<div fxLayout="column" class="dialog">
  <h1 class="title">
    {{ title | translate }}
  </h1>
  <div class="full-width">
    <p [innerHTML]="message | translate: { param: paramValue }"></p>
  </div>
  <form [formGroup]="rejectionForm">
    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ "general.justification" | translate }}</mat-label>
      <input formControlName="rejectionJustification" name="rejectionJustification" matInput maxlength="1000"/>
      <mat-hint align="end" class="count">
        {{ rejectionForm.get('rejectionJustification')?.value?.length || 0 }}/1000
      </mat-hint>
    </mat-form-field>
  </form>
  <div class="buttons-dialog" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="1%">
    <button class="button-dialog cancel-button" (click)="onCancel()" mat-flat-button>
      {{ "button.close" | translate }}
    </button>
    <button [disabled]="!rejectionForm.valid" class="button-dialog confirm-button"
            (click)="onConfirm()" mat-flat-button>
      {{ "button.confirm" | translate }}
    </button>
  </div>
</div>
